import React, { useEffect, useState } from 'react';

interface ExtendableGroupProps {
  label: string;
  extended?: boolean;
  modifiers?: string;
  onToggle?: () => void;
  children: React.ReactNode;
  forwardedRef?: React.RefObject<HTMLDivElement>;
}

const ExtendableGroup = ({
  label,
  extended = false,
  modifiers = '',
  onToggle,
  children,
  forwardedRef,
}: ExtendableGroupProps) => {
  const [isExtended, setExtended] = useState(extended);

  useEffect(() => {
    setExtended(extended);
  }, [extended]);

  const onToggleExtended = () => {
    setExtended(!isExtended);

    if (onToggle) {
      onToggle();
    }
  };

  return (
    <div
      data-am-extendgroup={modifiers}
      className={isExtended ? 'is-extended' : ''}
      ref={forwardedRef}
    >
      <div className="extend-group">{children}</div>
      <div className="extend-button-container">
        <button type="button" className="extend-button" title={label} onClick={onToggleExtended}>
          {label}
          <div data-am-icon="primary small hover" className="m-l-mini">
            <i className="icon-plus" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default ExtendableGroup;
